import React, { useContext, useState } from "react";
// import Account from "./Account";
import AdminSignup from "./AdminSignup";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import "./Signup.css";
// import DynamicStepper from "../../Common/Stepper/Stepper";
// import Company from "./Company";
// import Discovery from "./Discovery";
// import Role from "./Role";
// import InvideTeam from "./InvideTeam";
// import Purpose from "./Purpose";
// import BorderLinearProgressBar from "../../Common/Border-linear-process/BorderLinearProgress";
import { DynamicContext } from "../../Context/DynamicContext";
import SignupCompletion from "./SignupCompletion";
function MainSignupPage() {
  const { isSignupCompleted, isDarkMode } = useContext(DynamicContext);
  const steps = [
    { title: <span style={{ fontWeight: 600 }}>Account</span> },
    { title: <span style={{ fontWeight: 600 }}>Company</span> },
    // { title: <span style={{ fontWeight: 600 }}>Role</span> },
    // { title: <span style={{ fontWeight: 600 }}>Purpose</span> },
    // { title: <span style={{ fontWeight: 600 }}>Discovery</span> },
    { title: <span style={{ fontWeight: 600 }}>Invite Team</span> },
  ];

  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);
  const handleNext = (isValid) => {
    if (isValid) {
      if (!completedSteps.includes(activeStep)) {
        setCompletedSteps([...completedSteps, activeStep]);
      }
      setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
    }
  };

  const handleBack = () => {
    if (completedSteps.includes(activeStep)) {
      setCompletedSteps(completedSteps.filter((step) => step !== activeStep));
    }
    const stepsToKeep = completedSteps.filter((step) => step < activeStep);
    setCompletedSteps(stepsToKeep);

    setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  // const getStepContent = (step) => {
  //   switch (step) {
  //     case 0:
  //       return <Account onContinue={handleNext} onBack={handleBack} />;
  //     case 1:
  //       return <Company onContinue={handleNext} onBack={handleBack} />;
  //     case 2:
  //       return <Role onContinue={handleNext} onBack={handleBack} />;
  //     case 3:
  //       return <Purpose onContinue={handleNext} onBack={handleBack} />;
  //     case 4:
  //       return <Discovery onContinue={handleNext} onBack={handleBack} />;
  //     case 5:
  //       return <InvideTeam onContinue={handleNext} onBack={handleBack} />;
  //     default:
  //       return "Unknown step";
  //   }
  // };

  return (
    <>
      {isSignupCompleted ? (
        <SignupCompletion />
      ) : (
        <div
      className={`signup-outer-container ${isDarkMode ? "no-bg-image" : ""}`}
    >
          <div className="signup-icon-text">
            <img
              alt="VylabsIcon"
              src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
              className="vy-labs-logo"
            />
            <div className="signup-welcome-container">
              <h2 className="signup-main-header">
                Welcome to the future of recruitment
              </h2>
              <span className="signup-side-text">
                Smarter hiring starts here. Find, evaluate, and hire talent faster.
              </span>

              {/* <DynamicStepper
                steps={steps}
                activeStep={activeStep}
                completedSteps={completedSteps}
              /> */}
              {/* <div className="signup-progress-bar">
                <BorderLinearProgressBar
                  value={progress}
                  progressColor={progressColor}
                  sx={{ width: "100%", height: "8px" }}
                />
              </div> */}
              {/* <div className="step-counter">
                Step {activeStep + 1} of {steps.length}
              </div> */}
            </div>
          </div>
          <div className="stepper-render-ui">
            <AdminSignup onContinue={handleNext} onBack={handleBack} />
          </div>
        </div>
      )}
    </>
  );
}

export default MainSignupPage;
